import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Home.module.css';
import { FaArrowRight, FaShippingFast, FaUndo, FaTag, FaHeadset } from 'react-icons/fa';
import watchimage from '../../assets/images/watch.png';
import powerbankimage from '../../assets/images/power.png';
import headphoneImage from '../../assets/images/headphone.png';
import BlogSection from '../../components/BlogSection/BlogSection';

const translations = {
  en: {
    hero: [
      {
        title: "Comfort Meets Confidence – Plus Size Men's Tees",
        description: "Explore our premium collection of plus size t-shirts designed for the modern man. Perfect fit, breathable fabrics, and timeless style.",
        buttonText: "Shop T-Shirts",
        discount: "Get 15% Off First Order"
      },
      {
        title: "Elevate Your Basics – Everyday Essential Tees",
        description: "Solid, striped, or printed – our everyday t-shirts come in extended sizes and premium cotton for all-day comfort.",
        buttonText: "Browse Collection",
        discount: "Buy 2, Get 1 Free"
      },
      {
        title: "Stand Out with Oversized Graphic Tees",
        description: "Discover bold graphic t-shirts in relaxed, plus-size fits. Designed for comfort and style, perfect for any occasion.",
        buttonText: "Shop Graphic Tees",
        discount: "Up to 20% Off This Week"
      }
    ],
    advantages: {
      title: "Why Choose Aman x store?",
      desc: "We provide the best services and highest quality",
      free_shipping: "Free Shipping",
      free_shipping_desc: "Free delivery on all orders with secure shipping guarantee",
      easy_returns: "Easy Returns",
      easy_returns_desc: "30-day return policy with full refund guarantee",
      best_prices: "Best Prices",
      best_prices_desc: "We guarantee the best market prices with high quality",
      support: "24/7 Support",
      support_desc: "Our support team is available around the clock to help you"
    },
    testimonials: {
      title: "What Our Customers Say",
      desc: "Real experiences from our valued customers"
    },
    newsletter: {
      title: "Subscribe to Our Newsletter",
      desc: "Stay updated with our latest products and promotions!",
      placeholder: "Enter your email",
      button: "Subscribe"
    }
  },
  ar: {
    hero: [
      {
        title: "راحة وثقة – تيشيرتات رجالي مقاسات كبيرة",
        description: "اكتشف مجموعتنا المميزة من التيشيرتات الرجالي المقاسات الكبيرة. مقاس مثالي، أقمشة مريحة، وأسلوب عصري.",
        buttonText: "تسوق التيشيرتات",
        discount: "خصم 15% على أول طلب"
      },
      {
        title: "ارتقِ بأساسياتك – تيشيرتات يومية أساسية",
        description: "سادة، مخطط أو مطبوع – تيشيرتات يومية بمقاسات كبيرة وقماش قطني مريح طوال اليوم.",
        buttonText: "تصفح المجموعة",
        discount: "اشتري 2 واحصل على الثالث مجانًا"
      },
      {
        title: "تميّز بتيشيرتات جرافيك واسعة",
        description: "اكتشف تيشيرتات جرافيك جريئة بمقاسات واسعة ومريحة، مثالية لكل المناسبات.",
        buttonText: "تسوق تيشيرتات الجرافيك",
        discount: "خصومات حتى 20% هذا الأسبوع"
      }
    ],
    advantages: {
      title: "لماذا تختار Aman x store؟",
      desc: "نقدم أفضل الخدمات وأعلى جودة",
      free_shipping: "شحن مجاني",
      free_shipping_desc: "توصيل مجاني على جميع الطلبات مع ضمان الشحن الآمن",
      easy_returns: "إرجاع سهل",
      easy_returns_desc: "سياسة إرجاع لمدة 30 يومًا مع ضمان استرداد كامل",
      best_prices: "أفضل الأسعار",
      best_prices_desc: "نضمن أفضل الأسعار في السوق مع جودة عالية",
      support: "دعم 24/7",
      support_desc: "فريق الدعم متواجد دائمًا لمساعدتك"
    },
    testimonials: {
      title: "آراء عملائنا",
      desc: "تجارب حقيقية من عملائنا الكرام"
    },
    newsletter: {
      title: "اشترك في النشرة البريدية",
      desc: "تابع أحدث المنتجات والعروض لدينا!",
      placeholder: "أدخل بريدك الإلكتروني",
      button: "اشترك"
    }
  },
  tr: {
    hero: [
      {
        title: "Konfor ve Güven – Büyük Beden Erkek Tişörtleri",
        description: "Modern erkekler için tasarlanmış büyük beden tişört koleksiyonumuzu keşfedin. Mükemmel uyum, nefes alabilen kumaşlar ve zamansız stil.",
        buttonText: "Tişörtleri Satın Al",
        discount: "İlk Siparişte %15 İndirim"
      },
      {
        title: "Temel Parçalarınızı Yükseltin – Günlük Tişörtler",
        description: "Düz, çizgili veya baskılı – günlük tişörtlerimiz geniş beden seçenekleri ve kaliteli pamuk ile gün boyu konfor sunar.",
        buttonText: "Koleksiyonu İncele",
        discount: "2 Al, 1 Bedava"
      },
      {
        title: "Oversize Grafik Tişörtlerle Fark Yaratın",
        description: "Rahat, büyük beden grafik tişörtlerle cesur tarzı keşfedin. Her durum için mükemmel konfor ve stil.",
        buttonText: "Grafik Tişörtleri Satın Al",
        discount: "Bu Hafta %20'ye Varan İndirim"
      }
    ],
    advantages: {
      title: "Neden Aman x store?",
      desc: "En iyi hizmeti ve en yüksek kaliteyi sunuyoruz",
      free_shipping: "Ücretsiz Kargo",
      free_shipping_desc: "Tüm siparişlerde ücretsiz ve güvenli teslimat garantisi",
      easy_returns: "Kolay İade",
      easy_returns_desc: "30 gün iade politikası ve tam para iade garantisi",
      best_prices: "En İyi Fiyatlar",
      best_prices_desc: "En iyi piyasa fiyatlarını ve yüksek kaliteyi garanti ediyoruz",
      support: "7/24 Destek",
      support_desc: "Destek ekibimiz her zaman yardıma hazır"
    },
    testimonials: {
      title: "Müşterilerimiz Ne Diyor?",
      desc: "Değerli müşterilerimizin gerçek deneyimleri"
    },
    newsletter: {
      title: "Bültenimize Abone Olun",
      desc: "En yeni ürünlerimizden ve kampanyalarımızdan haberdar olun!",
      placeholder: "E-posta adresinizi girin",
      button: "Abone Ol"
    }
  }
};

function Home({ lang, setLang }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const t = translations[lang];

  const slides = [
    {
      ...t.hero[0],
      buttonLink: "/shop?category=plus-size-tshirts",
      image: watchimage,
      bgColor: "darkslategray"
    },
    {
      ...t.hero[1],
      buttonLink: "/shop?category=basic-tees",
      image: powerbankimage,
      bgColor: "gray"
    },
    {
      ...t.hero[2],
      buttonLink: "/shop?category=graphic-tees",
      image: headphoneImage,
      bgColor: "green"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const testimonialsData = [
    {
      name: {
        en: "Ahmed Sayed",
        ar: "أحمد سيد",
        tr: "Ahmed Sayed"
      },
      comment: {
        en: "This site is awesome, fast shipping and great products!",
        ar: "الموقع ده جامد أوي، الشحن سريع والمنتجات زي الفل!",
        tr: "Bu site harika, hızlı kargo ve harika ürünler!"
      },
      rating: 5
    },
    {
      name: {
        en: "Mohamed Khaled",
        ar: "محمد خالد",
        tr: "Mohamed Khaled"
      },
      comment: {
        en: "Prices are good but delivery took a bit longer.",
        ar: "الأسعار كويسة بس التوصيل أخد وقت شوية.",
        tr: "Fiyatlar iyi ama teslimat biraz uzun sürdü."
      },
      rating: 4
    },
    {
      name: {
        en: "Emad Hassan",
        ar: "عماد حسن",
        tr: "Emad Hassan"
      },
      comment: {
        en: "The site is easy and has everything, but support needs improvement.",
        ar: "الموقع سهل وكل حاجة موجودة، بس الدعم محتاج يتحسن.",
        tr: "Site kolay ve her şey var, ama destek geliştirilmeli."
      },
      rating: 3
    },
    {
      name: {
        en: "Karim Mahmoud",
        ar: "كريم محمود",
        tr: "Karim Mahmoud"
      },
      comment: {
        en: "Tech support is great, helped me choose a high-quality headset.",
        ar: "الدعم الفني مية مية، ساعدوني أختار  سماعه عالية.",
        tr: "Teknik destek harika, kaliteli bir kulaklık seçmemde yardımcı oldular."
      },
      rating: 5
    },
    {
      name: {
        en: "Ali Reda",
        ar: "علي رضا",
        tr: "Ali Reda"
      },
      comment: {
        en: "Products are very good, but I wish some were cheaper.",
        ar: "المنتجات كويسة جدًا، بس فيه حاجات كان نفسي تكون أرخص.",
        tr: "Ürünler çok iyi, keşke bazıları daha ucuz olsaydı."
      },
      rating: 4
    }
  ];

  return (
    <div className={styles.home}>
      {/* Remove local lang state and switcher UI, use props instead */}
      <section className={styles.heroSlider}>
        {/* Animated Background Circles */}
        <div className={styles.backgroundCircles}>
          <div className={styles.circle1}></div>
          <div className={styles.circle2}></div>
          <div className={styles.circle3}></div>
        </div>

        {/* Slider */}
        <div 
          className={styles.slidesContainer}
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div key={index} className={styles.slide}>
              <div className={styles.slideContent}>
                <div className={styles.discountTag}>
                  <span className={styles.rocketIcon}>🚀</span>
                  <span>Buy now {slide.discount}</span>
                </div>
                <h1>{slide.title}</h1>
                <p>{slide.description}</p>
                <Link to={slide.buttonLink} className={styles.shopButton}>
                  {slide.buttonText}
                  <FaArrowRight />
                </Link>
              </div>
              <div className={styles.slideImage}>
                <img src={slide.image} alt={slide.title} />
              </div>
            </div>
          ))}
        </div>

        {/* Slider Navigation */}
        <div className={styles.sliderNav}>
          {slides.map((_, index) => (
            <button
              key={index}
              className={`${styles.navDot} ${currentSlide === index ? styles.active : ''}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </section>

      {/* Advantages Section */}
      <section className={styles.advantages}>
        <div className={styles.sectionHeader}>
          <h2>{t.advantages.title}</h2>
          <p>{t.advantages.desc}</p>
        </div>
        <div className={styles.advantagesGrid}>
          <div className={styles.advantageCard}>
            <div className={styles.iconWrapper}>
              <FaShippingFast />
            </div>
            <h3>{t.advantages.free_shipping}</h3>
            <p>{t.advantages.free_shipping_desc}</p>
          </div>
          <div className={styles.advantageCard}>
            <div className={styles.iconWrapper}>
              <FaUndo />
            </div>
            <h3>{t.advantages.easy_returns}</h3>
            <p>{t.advantages.easy_returns_desc}</p>
          </div>
          <div className={styles.advantageCard}>
            <div className={styles.iconWrapper}>
              <FaTag />
            </div>
            <h3>{t.advantages.best_prices}</h3>
            <p>{t.advantages.best_prices_desc}</p>
          </div>
          <div className={styles.advantageCard}>
            <div className={styles.iconWrapper}>
              <FaHeadset />
            </div>
            <h3>{t.advantages.support}</h3>
            <p>{t.advantages.support_desc}</p>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <BlogSection lang={lang} />
      {/* Testimonials Section */}
      <section className={styles.testimonials}>
        <div className={styles.sectionHeader}>
          <h2>{t.testimonials.title}</h2>
          <p>{t.testimonials.desc}</p>
        </div>
        <div className={styles.testimonialSlider}>
          <div className={styles.testimonialTrack}>
            {[...testimonialsData, ...testimonialsData].map((testimonial, index) => (
              <div key={index} className={styles.testimonialCard}>
                <div className={styles.testimonialHeader}>
                  <img src="https://cdn-icons-png.flaticon.com/512/149/149071.png" alt={testimonial.name[lang]} />
                  <div className={styles.testimonialInfo}>
                    <h4>{testimonial.name[lang]}</h4>
                  </div>
                </div>
                <div className={styles.rating}>
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className={styles.star}>⭐</span>
                  ))}
                </div>
                <p>{testimonial.comment[lang]}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className={styles.newsletter}>
        <h2>{t.newsletter.title}</h2>
        <p>{t.newsletter.desc}</p>
        <form className={styles.subscribeForm}>
          <input type="email" placeholder={t.newsletter.placeholder} />
          <button type="submit">{t.newsletter.button}</button>
        </form>
      </section>
    </div>
  );
}

export default Home;